"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

exports.__esModule = true;
exports.initialState = {
  timings: {},
  count: {}
};

exports["default"] = function (state, action) {
  if (state === void 0) {
    state = exports.initialState;
  }

  switch (action.type) {
    case 'COUNT':
      {
        var times = state.count[action.name] || 0;
        return __assign({}, state, {
          count: __assign({}, state.count, (_a = {}, _a[action.name] = times + 1, _a))
        });
      }

    case 'TIME_START':
      {
        return __assign({}, state, {
          timings: __assign({}, state.timings, (_b = {}, _b[action.name] = {
            start: performance.now() || +new Date()
          }, _b))
        });
      }

    case 'TIME_END':
      {
        var timing = state.timings[action.name];
        var end = performance.now() || +new Date();
        var start = timing.start;
        var time = end - start;
        return __assign({}, state, {
          timings: __assign({}, state.timings, (_c = {}, _c[action.name] = __assign({}, timing, {
            end: end,
            time: time
          }), _c))
        });
      }

    default:
      {
        return state;
      }
  }

  var _a, _b, _c;
};